import { css } from 'styled-components';
import { pxToRem } from '../../../foundation/spacing/utils.js';

function getIconButtonSize(size) {
  switch (size) {
    case 'xs':
      return css(["width:", ";height:", ";[data-icon='falcon']{width:", ";height:", ";}"], pxToRem(24), pxToRem(24), pxToRem(12), pxToRem(12));
    case 'small':
      return css(["width:", ";height:", ";"], pxToRem(32), pxToRem(32));
    case 'large':
      return css(["width:", ";height:", ";"], pxToRem(48), pxToRem(48));
    case 'medium':
    default:
      return css(["width:", ";height:", ";"], pxToRem(40), pxToRem(40));
  }
}

export { getIconButtonSize };
